import { render, staticRenderFns } from "./bankCardSuccess.vue?vue&type=template&id=b8530206&scoped=true"
import script from "./bankCardSuccess.vue?vue&type=script&lang=js"
export * from "./bankCardSuccess.vue?vue&type=script&lang=js"
import style0 from "./bankCardSuccess.vue?vue&type=style&index=0&id=b8530206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8530206",
  null
  
)

export default component.exports